import type {PlayerManager} from 'chromecast-caf-receiver/cast.framework';

import {safeAccess} from '../../utils/objectUtils';

export class CAFv3PlayerProxy {
  constructor(private readonly rawPlayer: PlayerManager) {}

  addEventListener = ((...args: Parameters<PlayerManager['addEventListener']>) => {
    safeAccess(() => this.rawPlayer.addEventListener(...args));
  }) as PlayerManager['addEventListener']; // casting is needed because caf has many type definitions of this listener

  getCurrentTimeSec = () => safeAccess(() => this.rawPlayer.getCurrentTimeSec());

  getStats = () => safeAccess(() => this.rawPlayer.getStats());

  getMediaInformation = () => safeAccess(() => this.rawPlayer.getMediaInformation());

  getLiveSeekableRange = () => safeAccess(() => this.rawPlayer.getLiveSeekableRange());

  getTextTracksManager = () => safeAccess(() => this.rawPlayer.getTextTracksManager());

  getQueueManager = () => safeAccess(() => this.rawPlayer.getQueueManager());

  getAudioTracksManager = () => safeAccess(() => this.rawPlayer.getAudioTracksManager());
}
